import { formatDuration, type QueueItem } from '../lib/api';
import { youtubeThumbnailUrl } from '../lib/youtube';
import RemovalFlag from './RemovalFlag';
import './UpNext.css';

export default function UpNext({
  items,
  isAdmin,
  username,
  hasNowPlaying,
  onRemove,
  onPlay,
  onClear,
  onFlag,
}: {
  items: QueueItem[];
  isAdmin: boolean;
  username: string;
  hasNowPlaying?: boolean;
  onRemove: (id: string) => void;
  onPlay: (movieId: string) => void;
  onClear: () => void;
  onFlag: (id: string, flagged: boolean) => void;
}) {
  return (
    <section className="up-next panel fade-up">
      <div className="up-next-head">
        <h2 className="section-title">WATCH QUEUE</h2>
        {isAdmin && items.length > 0 && (
          <button className="btn btn-ghost" onClick={onClear}>
            Clear queue
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <p className="muted">
          {hasNowPlaying
            ? 'Nothing else queued yet. Request another movie to play next.'
            : 'No movies queued yet. Pick a public domain movie or paste a YouTube URL to get the night started.'}
        </p>
      ) : (
        <ol className="queue-list">
          {items.map((item) => {
            const thumb = youtubeThumbnailUrl(item.movie.youtube_video_id);
            const flaggedBy = item.flagged_by || [];
            return (
              <li key={item.id} className="queue-item">
                <span className="queue-pos" aria-hidden>
                  ▶
                </span>
                {thumb && (
                  <img
                    className="queue-thumb"
                    src={thumb}
                    alt=""
                    width={96}
                    height={54}
                  />
                )}
                <div className="queue-meta">
                  <strong className="queue-title">
                    {item.movie.title}
                    <RemovalFlag
                      isAdmin={isAdmin}
                      flagCount={item.flag_count || 0}
                      flaggedBy={flaggedBy}
                      flaggedByMe={flaggedBy.includes(username)}
                      onToggle={() => onFlag(item.id, !flaggedBy.includes(username))}
                    />
                  </strong>
                  <span className="muted">
                    {item.movie.duration_seconds
                      ? `${formatDuration(item.movie.duration_seconds)} · `
                      : ''}
                    Requested by {item.requested_by_username || 'someone'}
                  </span>
                </div>
                {isAdmin && (
                  <div className="queue-actions">
                    <button className="btn btn-primary" onClick={() => onPlay(item.movie.id)}>
                      Start Video
                    </button>
                    <button className="btn" onClick={() => onRemove(item.id)}>
                      Remove
                    </button>
                  </div>
                )}
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
}
